import { render, staticRenderFns } from "./ServicesPending.vue?vue&type=template&id=1c21834b&scoped=true&"
import script from "./ServicesPending.vue?vue&type=script&lang=js&"
export * from "./ServicesPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c21834b",
  null
  
)

export default component.exports